module.exports = __webpack_public_path__ + "static/media/error.ebdc8e76.svg";